const SavedAddressResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'savedaddresses/',
        apiRequestParams.defaults(),
        {
            create: {
                isArray: true,
                method: 'POST',
            },
            update: {
                isArray: true,
                method: 'PUT',
                url: appConfig.apiBaseUrl + 'savedaddresses/:savedAddressID',
            },
            delete: {
                method: 'DELETE',
                params: {
                    useAddressID: true,
                },
                url: appConfig.apiBaseUrl + 'savedaddresses/:addressID',
            },
        }
    );
};

module.exports = SavedAddressResource;
